function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 2048",
    style: {
      enableBackground: "new 0 0 2048 2048"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_39_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A24BDB"
    },
    points: "1768,1381.15 1707.41,1407.01 1681.55,1467.6 1655.8,1407.01 1595.21,1381.15  1655.8,1355.4 1681.55,1294.81 1707.41,1355.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D20763"
    },
    d: "M450.19,320.1c28.11,0,51.02,22.91,51.02,51.02c0,27.99-22.91,50.9-51.02,50.9 c-27.99,0-50.9-22.91-50.9-50.9C399.29,343.01,422.2,320.1,450.19,320.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3953"
    },
    d: "M1181.26,1249.23h0.11c0,24.68-10.07,47.09-26.31,63.33c-16.24,16.24-38.64,26.31-63.33,26.31 h-64.95v-89.64H1181.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 883.4,
    y: 1249.23,
    style: {
      fill: "#FF3953"
    },
    width: 143.38,
    height: 89.64
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 740.02,
    y: 1249.23,
    style: {
      fill: "#FF3953"
    },
    width: 143.38,
    height: 89.64
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3953"
    },
    d: "M740.02,1249.23v89.64h-64.96c-49.25,0-89.64-40.28-89.64-89.64H740.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 740.02,
    y: 1159.7,
    style: {
      fill: "#F1F1F1"
    },
    width: 143.38,
    height: 89.53
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F1F1"
    },
    d: "M1181.37,1249.23h-0.11h-154.48v-89.53h64.95C1141.1,1159.7,1181.37,1199.98,1181.37,1249.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 883.4,
    y: 1159.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 143.38,
    height: 89.53
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M740.02,1159.7v89.53h-154.6c0-24.63,10.1-47.01,26.35-63.23c16.25-16.23,38.67-26.3,63.29-26.3 H740.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E4347"
    },
    d: "M1173.82,891.25v44.76c0,55.98-45.83,101.81-101.81,101.81h-0.12 c-55.98,0-101.8-45.83-101.8-101.81v-44.76c0-55.98,45.82-101.81,101.8-101.81h0.12 C1127.99,789.44,1173.82,835.27,1173.82,891.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E4347"
    },
    d: "M782.18,891.25v44.76c0,55.98-45.82,101.81-101.92,101.81c-28,0-53.45-11.46-71.9-29.91 c-18.46-18.46-29.91-43.91-29.91-71.9v-44.76c0-55.98,45.82-101.81,101.81-101.81C736.36,789.44,782.18,835.27,782.18,891.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD93B"
    },
    d: "M991.23,392.73c318.52,0,576.7,357.62,576.7,676.03c0,318.53-258.18,576.71-576.7,576.71 c-318.41,0-576.59-258.18-576.59-576.71C414.64,750.35,672.82,392.73,991.23,392.73z M1173.82,936.01v-44.76 c0-55.98-45.83-101.81-101.81-101.81h-0.12c-55.98,0-101.8,45.83-101.8,101.81v44.76c0,55.98,45.82,101.81,101.8,101.81h0.12 C1127.99,1037.82,1173.82,991.99,1173.82,936.01z M1181.37,1249.23c0-49.25-40.27-89.53-89.64-89.53h-64.95H883.4H740.02h-64.96 c-24.62,0-47.04,10.07-63.29,26.3c-16.25,16.22-26.35,38.6-26.35,63.23c0,49.36,40.39,89.64,89.64,89.64h64.96H883.4h143.38 h64.95c24.69,0,47.09-10.07,63.33-26.31C1171.3,1296.32,1181.37,1273.91,1181.37,1249.23z M782.18,936.01v-44.76 c0-55.98-45.82-101.81-101.92-101.81c-55.99,0-101.81,45.83-101.81,101.81v44.76c0,27.99,11.45,53.44,29.91,71.9 c18.45,18.45,43.9,29.91,71.9,29.91C736.36,1037.82,782.18,991.99,782.18,936.01z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M991.23,1669.504c-81.067,0-159.724-15.886-233.786-47.217 c-71.524-30.258-135.755-73.568-190.909-128.729c-55.155-55.164-98.461-119.406-128.715-190.945 c-31.329-74.08-47.214-152.76-47.214-233.853c0-80.262,16.193-166.141,46.829-248.351 c30.064-80.677,74.118-158.193,127.398-224.168c56.051-69.405,120.064-124.463,190.262-163.644 c75.967-42.402,155.415-63.901,236.135-63.901c80.746,0,160.213,21.499,236.197,63.9 c70.212,39.18,134.236,94.238,190.295,163.644c53.287,65.973,97.346,143.489,127.412,224.168 c30.637,82.209,46.83,168.087,46.83,248.352c0,81.095-15.886,159.774-47.216,233.853 c-30.257,71.541-73.566,135.784-128.729,190.946c-55.161,55.162-119.403,98.473-190.942,128.729 C1151,1653.618,1072.322,1669.504,991.23,1669.504z M991.23,416.764c-141.654,0-279.804,74.465-389,209.678 C499.816,753.254,438.674,918.607,438.674,1068.76c0,304.746,247.875,552.676,552.556,552.676 c304.741,0,552.666-247.93,552.666-552.676c0-150.159-61.146-315.511-163.568-442.317 C1271.116,491.229,1132.932,416.764,991.23,416.764z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1343.322,750.057c-7.76,0-15.374-3.75-20.008-10.686 c-38.516-57.655-84.911-106.72-134.17-141.891c-10.803-7.713-13.308-22.723-5.595-33.526 c7.713-10.802,22.724-13.309,33.526-5.594c54.71,39.062,103.901,90.98,146.209,154.309c7.373,11.038,4.403,25.962-6.635,33.336 C1352.55,748.745,1347.91,750.057,1343.322,750.057z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M352.28,572.784c-13.274,0-24.034-10.76-24.034-24.034v-24.92 c0-13.274,10.76-24.034,24.034-24.034s24.034,10.76,24.034,24.034v24.92C376.314,562.024,365.554,572.784,352.28,572.784z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M424.44,620.144h-24.8c-13.274,0-24.034-10.76-24.034-24.034s10.76-24.034,24.034-24.034h24.8 c13.274,0,24.034,10.76,24.034,24.034S437.714,620.144,424.44,620.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M352.28,692.304c-13.274,0-24.034-10.76-24.034-24.034v-24.8 c0-13.274,10.76-24.034,24.034-24.034s24.034,10.76,24.034,24.034v24.8C376.314,681.544,365.554,692.304,352.28,692.304z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M304.92,620.144H280c-13.274,0-24.034-10.76-24.034-24.034s10.76-24.034,24.034-24.034h24.92 c13.274,0,24.034,10.76,24.034,24.034S318.194,620.144,304.92,620.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M450.19,446.054c-41.319,0-74.934-33.615-74.934-74.934c0-41.385,33.615-75.054,74.934-75.054 c41.385,0,75.054,33.669,75.054,75.054C525.244,412.439,491.575,446.054,450.19,446.054z M450.19,344.134 c-14.814,0-26.866,12.106-26.866,26.986c0,14.814,12.052,26.866,26.866,26.866c14.88,0,26.986-12.052,26.986-26.866 C477.176,356.24,465.07,344.134,450.19,344.134z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1681.55,1491.634c-0.006,0-0.012,0-0.019,0c-9.634-0.007-18.333-5.767-22.101-14.634 l-21.966-51.684l-51.689-22.061c-8.86-3.782-14.607-12.489-14.6-22.124c0.007-9.634,5.767-18.333,14.634-22.101l51.664-21.957 l21.956-51.665c3.769-8.867,12.468-14.626,22.102-14.634c0.006,0,0.013,0,0.019,0c9.628,0,18.325,5.744,22.105,14.6 l22.062,51.69l51.684,21.966c8.867,3.768,14.627,12.467,14.634,22.101c0.008,9.635-5.739,18.342-14.6,22.124l-51.71,22.069 l-22.069,51.709C1699.876,1485.889,1691.177,1491.634,1681.55,1491.634z M1656.548,1381.197l8.687,3.707 c5.711,2.438,10.257,6.99,12.685,12.705l3.678,8.653l3.708-8.688c2.433-5.699,6.972-10.238,12.671-12.671l8.687-3.707 l-8.652-3.678c-5.715-2.428-10.268-6.974-12.705-12.685l-3.708-8.688l-3.677,8.653c-2.434,5.727-6.993,10.285-12.72,12.719 L1656.548,1381.197z M1655.8,1355.4h0.01H1655.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1481.95,1632.294c-13.273,0-24.034-10.761-24.034-24.034v-24.8 c0-13.273,10.761-24.034,24.034-24.034s24.034,10.761,24.034,24.034v24.8C1505.984,1621.533,1495.224,1632.294,1481.95,1632.294 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1554.11,1679.774h-24.801c-13.273,0-24.034-10.761-24.034-24.034s10.761-24.034,24.034-24.034 h24.801c13.273,0,24.034,10.761,24.034,24.034S1567.384,1679.774,1554.11,1679.774z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1481.95,1751.935c-13.273,0-24.034-10.761-24.034-24.034V1703.1 c0-13.273,10.761-24.034,24.034-24.034s24.034,10.761,24.034,24.034v24.801 C1505.984,1741.174,1495.224,1751.935,1481.95,1751.935z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1434.47,1679.774h-24.8c-13.273,0-24.034-10.761-24.034-24.034s10.761-24.034,24.034-24.034 h24.8c13.273,0,24.034,10.761,24.034,24.034S1447.743,1679.774,1434.47,1679.774z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M680.26,1061.854c-33.498,0-65.067-13.122-88.895-36.95 c-23.827-23.827-36.949-55.397-36.949-88.895v-44.76c0-69.391,56.453-125.844,125.844-125.844 c69.452,0,125.955,56.454,125.955,125.844v44.76C806.214,1005.401,749.711,1061.854,680.26,1061.854z M680.26,813.474 c-42.885,0-77.775,34.89-77.775,77.776v44.76c0,20.658,8.122,40.158,22.87,54.906c14.749,14.748,34.248,22.871,54.905,22.871 c42.947,0,77.886-34.891,77.886-77.776v-44.76C758.146,848.364,723.207,813.474,680.26,813.474z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1072.01,1061.854h-0.12c-69.385,0-125.834-56.454-125.834-125.845v-44.76 c0-69.391,56.449-125.844,125.834-125.844h0.12c69.391,0,125.845,56.454,125.845,125.844v44.76 C1197.854,1005.401,1141.4,1061.854,1072.01,1061.854z M1071.89,813.474c-42.88,0-77.766,34.89-77.766,77.776v44.76 c0,42.886,34.886,77.776,77.766,77.776h0.12c42.886,0,77.776-34.891,77.776-77.776v-44.76c0-42.886-34.891-77.776-77.776-77.776 H1071.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1091.73,1362.904H675.06c-62.68,0-113.674-50.994-113.674-113.674 c0-30.242,11.864-58.739,33.405-80.241c21.513-21.487,50.021-33.323,80.269-33.323h416.67 c62.68,0,113.674,50.944,113.674,113.564c0,30.293-11.844,58.819-33.351,80.324 C1150.55,1351.061,1122.023,1362.904,1091.73,1362.904z M675.06,1183.734c-17.419,0-33.864,6.844-46.306,19.271 c-12.448,12.425-19.3,28.84-19.3,46.226c0,36.175,29.431,65.605,65.606,65.605h416.67c17.453,0,33.908-6.844,46.334-19.271 c12.428-12.427,19.271-28.882,19.271-46.335c0-36.114-29.431-65.496-65.605-65.496H675.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1181.26,1273.265H585.42c-13.274,0-24.034-10.761-24.034-24.034s10.76-24.034,24.034-24.034 h595.84c13.273,0,24.034,10.761,24.034,24.034S1194.533,1273.265,1181.26,1273.265z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M740.02,1362.904c-13.274,0-24.034-10.761-24.034-24.034V1159.7 c0-13.273,10.76-24.034,24.034-24.034s24.034,10.761,24.034,24.034v179.17C764.054,1352.144,753.294,1362.904,740.02,1362.904z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M883.4,1362.904c-13.274,0-24.034-10.761-24.034-24.034V1159.7 c0-13.273,10.76-24.034,24.034-24.034s24.034,10.761,24.034,24.034v179.17C907.434,1352.144,896.674,1362.904,883.4,1362.904z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1026.78,1362.904c-13.274,0-24.034-10.761-24.034-24.034V1159.7 c0-13.273,10.76-24.034,24.034-24.034c13.273,0,24.034,10.761,24.034,24.034v179.17 C1050.814,1352.144,1040.054,1362.904,1026.78,1362.904z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.7aa193ce9b1e51a8b3a7d53534c56ce7.svg";
export { ForwardRef as ReactComponent };